import {Injectable} from '@angular/core';
import {AbstractDataServiceDtoAdapter} from 'src/app/modules/core/service/v2/dataservice/adapter/abstractDataServiceDto.adapter';
import {SaleProductDataService} from './SaleProductData.service';
import {SaleProductModel} from '../../../api/entity/saleProduct.model';
import {SaleProductConverter} from '../../../api/converter/saleProduct.converter';


@Injectable({providedIn: 'root'})
export class SaleProductDataServiceAdapter extends
    AbstractDataServiceDtoAdapter<SaleProductModel, SaleProductConverter> {
    constructor(dataService: SaleProductDataService, converter: SaleProductConverter) {
        super(dataService, converter);
    }
    newStoredEntityInstance(): SaleProductModel {
        return new SaleProductModel();
    }
}
